'use client';
import { useState, useEffect } from 'react';
import Image from 'next/image';

interface ImageWithFallbackProps
  extends Omit<React.ComponentProps<typeof Image>, 'src' | 'alt'> {
  fallbackImage?: string;
  alt: string;
  src?: string;
}

export default function ImageWithFallback({
  fallbackImage = '/warning.png',
  alt,
  src,
  ...props
}: ImageWithFallbackProps) {
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <Image
      alt={alt}
      onError={() => setError(true)}
      src={error ? fallbackImage : src ?? fallbackImage}
      {...props}
    />
  );
}
